import { MaterialIcon } from "@website/icons/material";
import { Accordion } from "@website/ui/accordion";
import { FC } from "react";

export type FaqType = {
  title: string;
  list: Array<{
    answer: string;
    question: string;
  }>;
};

const Faq: FC<FaqType> = ({ title, list }) => (
  <article className="w-full py-8">
    <div className="mb-4 flex h-8 flex-row items-center gap-2">
      <div className="text-on-surface-medium-emphasis size-5 overflow-hidden text-xl leading-5">
        <MaterialIcon name="help_outline" />
      </div>
      <h2 className="text-on-surface-high-emphasis lg:text-headline-6 text-base">
        {title}
      </h2>
    </div>
    <div
      itemScope
      className="flex flex-col space-y-4"
      itemType="https://schema.org/FAQPage"
    >
      {list.map((item, index) => (
        <Accordion
          content={item.answer}
          initialExpanded={index <= 3}
          key={item.question}
          title={item.question}
        />
      ))}
    </div>
  </article>
);
export default Faq;
